<template>
    <div class="image-text-container">
        <img :src="imageSrc" style="width: 100%" alt="image" />
        <span v-for="(item, index) in textItems" :key="index" :style="getCombinedStyle(item.style)">
            {{ item.content }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'ImageText',
    props: {
        imageWidth: {
            type: Number,
            required: true
        },
        imageSrc: {
            type: String,
            required: true
        },
        textItems: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data() {
        return {
            windowWidth: window.innerWidth
        }
    },
    computed: {
        baseWidth() {
            // 计算基准宽度，最大不超过580
            return Math.min(this.windowWidth * 0.8, 580)
        }
    },
    methods: {
        calculatePosition(value) {
            // 使用限制后的baseWidth进行比例计算
            return (this.baseWidth / this.imageWidth) * value
        },
        getCombinedStyle(styleString) {
            let resultStyle = styleString || ''

            // 处理top
            const topRegex = /top\s*:\s*([^;]+)/i
            if (topRegex.test(resultStyle)) {
                resultStyle = resultStyle.replace(topRegex, (match, value) => {
                    return `top: ${this.calculatePosition(value)}px`
                })
            } else {
                resultStyle += `${resultStyle ? ';' : ''}top: 0px`
            }

            // 处理left
            const leftRegex = /left\s*:\s*([^;]+)/i
            if (leftRegex.test(resultStyle)) {
                resultStyle = resultStyle.replace(leftRegex, (match, value) => {
                    return `left: ${this.calculatePosition(value)}px`
                })
            } else {
                resultStyle += `${resultStyle ? ';' : ''}left: 0px`
            }

            // 添加基础样式
            //resultStyle += `${resultStyle ? ';' : ''}margin: 0;padding: 0;`

            return resultStyle
        }
    },
}
</script>

<style scoped>
.image-text-container {
    position: relative;
    display: inline-block;
}

img {
    display: block;
}
</style>